var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({attrs:{"color":"primary","dark":"","elevation":"0","icon":""}},_vm.$listeners),[_c('v-icon',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }